import { useContext } from 'react'
import { Box, Divider, Paper, Table, TableBody, TableContainer } from '@material-ui/core'

import ContentManagementContext, { BulkContentItem, Content } from '../../../ContentManagementProvider/Context'
import ContentTableHeader from './ContentTableHeader'
import Pagination from './ContentTablePagination'
import ContentTableRow from './ContentTableRow'

import BulkEdit from './BulkEdit'
import Filter from './Filter'
import ContentTableEmptyState from '../ContentTableEmptyState'

type ContentTableProps = {
  content: Content
  hasUnfilteredContent?: boolean
  viewOnly?: boolean
}

const ContentTable = ({ content, hasUnfilteredContent = true, viewOnly }: ContentTableProps) => {
  const {
    selectedContent,
    onSelectAllContent,
    onBulkUpdateContentVisibility,
    onBulkDeleteContent,
    handleTableFiltering,
  } = useContext(ContentManagementContext)
  // All currently viewable content items in the table are selected
  const allViewableContentSelected = content.items.every((c) => selectedContent?.find((sc) => sc.id === c.id))
  // At least one currently viewable content item in the table is selected
  const viewableContentSelected = content.items.some((c) => selectedContent?.find((sc) => sc.id === c.id))
  return (
    <Paper elevation={0}>
      <Box p={2}>
        {/* Show bulk edit per table page, only show if at least one currently viewable items is selected */}
        {viewableContentSelected ? (
          <BulkEdit
            onBulkUpdateContentVisibility={onBulkUpdateContentVisibility}
            onBulkDeleteContent={onBulkDeleteContent}
          />
        ) : (
          <Filter />
        )}
      </Box>
      <Divider />
      <TableContainer>
        <Table>
          <ContentTableHeader
            viewOnly={viewOnly}
            someContentSelected={viewableContentSelected}
            allContentSelected={allViewableContentSelected && hasUnfilteredContent}
            onSelectAllContent={onSelectAllContent}
          />
          {hasUnfilteredContent && (
            <TableBody>
              {content.items.map((row, idx) => (
                <ContentTableRow
                  key={idx}
                  data={row}
                  viewOnly={viewOnly}
                  selected={Boolean(selectedContent?.find((item: BulkContentItem) => item.id === row.id))}
                />
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {hasUnfilteredContent ? (
        <Pagination count={content.total} />
      ) : (
        <ContentTableEmptyState
          isFiltered
          clearFilters={() => handleTableFiltering()}
        />
      )}
    </Paper>
  )
}

export default ContentTable
